module.exports = __webpack_public_path__ + "static/media/sub-banner-02-1.4e7d64d4.jpg";